// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TableSkeleton_tableSkeleton__dtNLj table tr {
    background-color: transparent !important;
}`, "",{"version":3,"sources":["webpack://./src/Components/atoms/TableSkeleton/TableSkeleton.module.css"],"names":[],"mappings":"AAAA;IACI,wCAAwC;AAC5C","sourcesContent":[".tableSkeleton table tr {\n    background-color: transparent !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableSkeleton": `TableSkeleton_tableSkeleton__dtNLj`
};
export default ___CSS_LOADER_EXPORT___;
